module.exports = __webpack_public_path__ + "img/ProductServe_01.4bc82aa8.jpg";